export enum LookUp {
  AssetType = 2,
  CreditRating = 3,
  PropertyStatus = 6,
  LeaseStructure = 12,
  OwnershipType = 13,
  Rating = 16,
  Strategies = 20,
  Geography = 21,
  DocumentCategorySub = 32
}
export enum UserRole {
  Admin = 1,
  Principal = 2,
  Broker = 3,
  Principal1031 = 4,
  InternalUser = 5,
  CoBroker = 6,
  ComplianceBroker = 7,
  GuestUser = 8,
  DataEntryStaff = 9,
  ExternalBroker = 10,
  Seller = 13,
  SuperAdmin = 14
}
export enum UserStatus {
  Active = 101,
  Inactive = 102,
  OnHold = 103,
  Deleted = 104
}
export enum DocumentType {
  OfferingMemorandom = 401,
  Survey = 402,
  Title = 403,
  PropertyCondition = 404,
  Lease = 405,
  Financing = 406,
  Maintenance = 407,
  OfferDocument = 408,
  OfferDocAccess = 409,
  DueDiligenceDocAccess = 410
}

export enum DocAccessStatus {
  New = 504,
  Pending = 501,
  Accepted = 502,
  Rejected = 503,
  Invited = 505
}
export enum ContactType {
  Primary = 551,
  Secondary = 552,
  Others = 553
}
export enum PropertyFor {
  Sale = 601,
  Exchange1031 = 602
}
export enum YesNo {
  Yes = 1051,
  No = 1052
}

export enum TaskStatus {
  New = 2250,
  InProgress = 2251,
  Completed = 2252
}
export enum PropertyStatus {
  Available = 351,
  UnderContract = 352,
  Closed = 353,
  Sold = 354,
  NotAvailable = 355,
  OffMarket = 356,
  PendingApproval = 357,
  Rejected = 358,
  Draft = 359,
  PrincipalDraft = 6949,
}
export enum RatingAgency {
  SandPRating = 2800,
  MoodysRating = 2801,
  FitchRating = 2802,
}
export enum Modules {
  Employees = 7251,
  ExternalUsers = 7252,
  TaskMaster = 7253,
  Brokerages = 7254,
  TenantMaster = 7255,
  GuarantorMaster = 7256,
  BuyerCriteria = 7257,
  Prospects = 7258,
  ActivityLog = 7259,
  City= 7260,
  PropertyType = 7261,
  DealTeamContactType = 7262,
  ExpenseMaster = 7263,
  MetaTag = 7264,
  FileCategory = 7265,
  LiveListings = 7267,
}
export enum Actions {
  Create = 7351,
  Listings = 7352,
  Edit = 7353,
  Delete = 7354,
  BulkUpdate = 7355,
  ViewSite = 7356,
  ViewOffers = 7357,
  AssociationsList = 7358,
  AssociationsEdit = 7359,
  ChangePassword = 7360,
  UserAnalytics = 7361,
  RegistrationStats = 7362,
  PermissionandAccess = 7363,
  Details = 7364,
  SellerDashboardAccess = 7365,
}

